import { useDispatch } from 'react-redux';
import { eventActions } from '../../../../store/modules/event';
import { appActions } from '../../../../store/modules/app';

const useEventInProgressListUtils = (inProgressEvent) => {
  const dispatch = useDispatch();

  const setData = (args) => {
    return dispatch(eventActions.setData(args));
  };

  /**
   * 진행중인 기획전 초기화 하기
   */
  const setInitialInProgressEventList = () => {
    const { originalInProgressEventList } = inProgressEvent;
    setData({
      path: ['inProgressEvent', 'inProgressEventList', 'list'],
      value: originalInProgressEventList,
    });
  };

  const openEventItemListModal = (data) => {
    dispatch(appActions.openEventItemListModal(data));
  };

  return {
    setInitialInProgressEventList,
    openEventItemListModal,
  };
};

export default useEventInProgressListUtils;
